"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
/* eslint-disable no-useless-catch */
class AlertAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    getAllAlerts(organizationId, source, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.alert, {
                    signal: abortContext === null || abortContext === void 0 ? void 0 : abortContext.newAbortSignal(new AbortController()),
                    headers: Object.assign(Object.assign({}, (organizationId && {
                        "x-hhn-active-org-id": organizationId,
                    })), (source && { "x-hhn-source": source })),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    fetchAcknowledgements(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.acknowledgement, {
                    params,
                });
                return response.data.data.acknowledgement;
            }
            catch (e) {
                throw e;
            }
        });
    }
    fetchSentAcknowledgements(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.sentAcknowledgement, {
                    params,
                });
                return response.data.data.sentAcknowledgement;
            }
            catch (e) {
                throw e;
            }
        });
    }
    fetchPriorityAlerts(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.priority, {
                    params,
                });
                return response.data.data.priority;
            }
            catch (e) {
                throw e;
            }
        });
    }
    handleReferrals(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.referrals, data);
                return response.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.AlertAdapter = AlertAdapter;
